import React from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import Routes from './Routes';

function App() {
  return (
    <ErrorBoundary>
      <Routes />
    </ErrorBoundary>
  );
}

export default App;
